import type { FC } from 'react';
import { useStorageServiceRoot } from 'src/apis/storage/use-storage-service-root';
import { PageSpinner } from 'src/components/spinner-container';
import { StorageAllocationsForOperators } from 'src/pages/storage/allocations/overview/for-operators';
import { StorageAllocationsForShippers } from 'src/pages/storage/allocations/overview/for-shippers';
import { Forbidden } from 'src/utils/errors';

export const StorageAllocations: FC = () => {
  const storageServiceRoot = useStorageServiceRoot();

  if (!storageServiceRoot.response) {
    return <PageSpinner />;
  }

  const isOperator =
    storageServiceRoot.response.data._links.getAllocationsOverviewForOperator;
  const isShipper =
    storageServiceRoot.response.data._links.getAllocationsOverviewForShipper;

  if (isOperator) {
    return (
      <StorageAllocationsForOperators storageServiceRoot={storageServiceRoot} />
    );
  } else if (isShipper) {
    return (
      <StorageAllocationsForShippers storageServiceRoot={storageServiceRoot} />
    );
  } else {
    throw new Forbidden();
  }
};
